export default Object.freeze({
  POLICY_EXCESS: 527340001,
  MEMBER_EXCESS: 527340002,
  NONE: 527340000,
});